function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getStore } from 'global-box';
import { defaultNumberFormatResolver, defaultTimeFormatResolver, defaultCategoricalColorScaleResolver, defaultColorSchemeResolver } from './resolvers';
const CACHE_KEY = '@encodable/encodable:options';

class OptionsManager {
  constructor() {
    _defineProperty(this, "state", void 0);

    this.state = getStore().getOrCreate(CACHE_KEY, () => ({}));
  }

  getNumberFormatResolver() {
    return this.state.numberFormatResolver ?? defaultNumberFormatResolver;
  }

  setNumberFormatResolver(resolver) {
    this.state.numberFormatResolver = resolver;
    return this;
  }

  resetNumberFormatResolver() {
    return this.setNumberFormatResolver(undefined);
  }

  resolveNumberFormat(...params) {
    return this.getNumberFormatResolver()(...params);
  }

  getTimeFormatResolver() {
    return this.state.timeFormatResolver ?? defaultTimeFormatResolver;
  }

  setTimeFormatResolver(resolver) {
    this.state.timeFormatResolver = resolver;
    return this;
  }

  resetTimeFormatResolver() {
    return this.setTimeFormatResolver(undefined);
  }

  resolveTimeFormat(...params) {
    return this.getTimeFormatResolver()(...params);
  }

  getCategoricalColorScaleResolver() {
    return this.state.categoricalColorScaleResolver ?? defaultCategoricalColorScaleResolver;
  }

  setCategoricalColorScaleResolver(resolver) {
    this.state.categoricalColorScaleResolver = resolver;
    return this;
  }

  resetCategoricalColorScaleResolver() {
    return this.setCategoricalColorScaleResolver(undefined);
  }

  resolveCategoricalColorScale(...params) {
    return this.getCategoricalColorScaleResolver()(...params);
  }

  getColorSchemeResolver() {
    return this.state.colorSchemeResolver ?? defaultColorSchemeResolver;
  }

  setColorSchemeResolver(resolver) {
    this.state.colorSchemeResolver = resolver;
    return this;
  }

  resetColorSchemeResolver() {
    return this.setColorSchemeResolver(undefined);
  }

  resolveColorScheme(...params) {
    return this.getColorSchemeResolver()(...params);
  }

}

const Encodable = new OptionsManager();
export default Encodable;